export enum AnalyticsEvent {
  CampaignCreationStarted = "campaign_creation_started",
  OfferingInfoCompleted = "offering_info_completed",
  AiAssistantUsed = "ai_assistant_used",
  DataConnectionCompleted = "data_connection_completed",
  SuggestTitlesClicked = "suggest_titles_clicked",
  AddTitlesClicked = "add_titles_clicked",
  AudienceExpansionOpened = "audience_expansion_opened",
}

export enum AiAssistantName {
  GeoTargeting = "geo_targeting",
  JobTitles = "job_titles",
}

export enum ConnectionMethod {
  HubSpot = "hubspot",
  Salesforce = "salesforce",
  Marketo = "marketo",
  ManualUpload = "manual_upload",
  CID = "cid",
}

export enum InputType {
  Url = "url",
  FileUpload = "file_upload",
}

export enum AnalyticsStatus {
  Success = "success",
  Failure = "failure",
}

export type AnalyticsEventMap = {
  [AnalyticsEvent.CampaignCreationStarted]: Record<string, never>;

  [AnalyticsEvent.OfferingInfoCompleted]: {
    input_type: InputType;
    status: AnalyticsStatus;
    duration_ms: number;
  };
  [AnalyticsEvent.AiAssistantUsed]: {
    wizard_step: 2 | 3;
    assistant_name: AiAssistantName;
  };
  [AnalyticsEvent.DataConnectionCompleted]: {
    campaign_id: string;
    connection_method: ConnectionMethod;
    input_type: InputType;
  };
  [AnalyticsEvent.SuggestTitlesClicked]: {
    campaign_id: string;
    result_count: number;
  };
  [AnalyticsEvent.AddTitlesClicked]: {
    campaign_id: string;
  };
  [AnalyticsEvent.AudienceExpansionOpened]: {
    campaign_id: string;
    account_id: string;
  };
};

export type AnalyticsEventName = keyof AnalyticsEventMap;
